import { useQuery } from '@apollo/client';
import {
  FETCH_CUSTODIAN_ACTIVITY_METRICS,
  type FetchCustodianActivityMetricsQuery,
  type FetchCustodianActivityMetricsQueryVariables,
} from '../utils/activities.queries';
import {
  type ActivitiesMetricsTiles,
  mapActivitiesMetrics,
} from '../utils/mapActivitiesMetrics';

export type UseActivitiesMetricsResult = {
  tiles: ActivitiesMetricsTiles;
  hasData: boolean;
  loading: boolean;
  error: Error | undefined;
  refetch: () => Promise<unknown>;
};

export const useActivitiesMetrics = (
  organizationId?: string,
  enabled = true,
): UseActivitiesMetricsResult => {
  const { data, loading, error, refetch } = useQuery<
    FetchCustodianActivityMetricsQuery,
    FetchCustodianActivityMetricsQueryVariables
  >(FETCH_CUSTODIAN_ACTIVITY_METRICS, {
    skip: !organizationId || !enabled,
    variables: {
      input: { organizationId },
    },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const metrics = data?.fetchCustodianActivityMetrics?.metrics;

  return {
    tiles: mapActivitiesMetrics(metrics),
    hasData: metrics != null,
    loading: loading && !data,
    error,
    refetch,
  };
};
